import { FC } from 'react';
import { navigate } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import { ButtonOutlinePrimary } from '@lambdacurry/component-library';
import { Card, CardContent, Grid } from 'lib/components';
import { RegistrationStep } from '../../store';
import { GettingStartedContent, GettingStartedLayout, GettingStartedNoCookingFooter } from '../../components';
import { default as LoginPattern } from '../../assets/login-pattern.svg';

const SuccessPage: FC = () => (
  <GettingStartedLayout className="getting-started-success" step={RegistrationStep.success}>
    <GettingStartedContent>
      <Grid>
        <div className="col-span-12 lg:col-span-10 lg:col-start-2">
          <Card className="relative">
            <div className="flex flex-col-reverse md:flex-row">
              <CardContent>
                <div className="max-w-lg">
                  <h2>Your Box Is Being Prepared By Chef Robert!</h2>
                  <p>
                    Robert and his team will hand-pick your meals each week. You can visit your dashboard to tell us
                    what your favorite meals are each week, and we will continue to update our selections for your
                    tastes.
                  </p>
                </div>
                <ButtonOutlinePrimary className="w-56 mt-4" onClick={() => navigate('/')}>
                  View Your Box
                </ButtonOutlinePrimary>
              </CardContent>
              <CardContent className="md:min-h-[300px] !border-0 md:!p-8 !pb-0 flex justify-center">
                <div className="w-56 md:w-72">
                  <StaticImage
                    className="mx-auto max-w-full"
                    src="../../assets/plated_ingredients.jpg"
                    alt="plated ingredients"
                    placeholder="tracedSVG"
                    objectFit="contain"
                  />
                </div>
              </CardContent>
            </div>
            <LoginPattern className="lg:w-full lg:h-auto bg-brand-green-50" />
          </Card>
        </div>
      </Grid>
    </GettingStartedContent>

    <GettingStartedNoCookingFooter />
  </GettingStartedLayout>
);

export default SuccessPage;
